export const reports = {
    route: 'Reporty',
    overAll: 'Celkovo',
    byDevice: 'Podľa zariadení',
    reportTitle: 'Toto je report, ktorý sme získali z informácií na základe meraní z watt-metra za mesiac: ',
    compare: 'Vaša spotreba za posledný mesiac v porovnaní s predchádzajúcim mesiacom:',
    kwhMissing: 'Zadajte svoju cenu za kWh v mobilnej aplikácii v časti: Účet / Nastavenia / Cena za kWh',
    monthlyConsumption: 'Vaša mesačná spotreba (kWh):',
    mostRelevant: 'Najrelevantnejšie použitia:',
    alwaysOn: 'Vždy zapojené zariadenia',
    graphTips: 'Na tomto grafe sú oranžové čiary znázornené v ktorom čase počas dňa (os X), a v ktorý deň v mesiaci (os Y) ste zariadenie použili.',
    deviceReport: 'Spotreba energie vášho zariadenia:',
    savingPotentials: 'Potenciál úspor',
    myAvgKwh: 'Spotreba môjho zariadenia za posledných 30 dní',
    avgKwh: 'Rozsah pre zariadenie toho istého typu',
    myAvgW: 'Príkon zariadenia',
    avgW: 'Rozsah pre zariadenie toho istého typu',
    kwhCost: 'Náklady na kilowatt',
    wattUnit: 'Watt',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogram',
    costUnit: '€'
};
